import React, { Component } from 'react';
import { connect } from 'react-redux';
import CommissionSelector from "./CommissionSelector";
import { fetch_commissions, select_commission } from "../redux/actions";
import Paginator from "../../hoc/Paginator/Paginator";

class CommissionSelectorContainer extends Component {
    componentDidMount() {
        this.props.fetch_commissions(this.props.currentPage)
        localStorage.removeItem('searchValue');
        localStorage.removeItem('sortParams');
    }

    onCommissionSelect = (commission) => {
        if (commission.caseId !== null) {
            this.props.history.push("/cases/" + commission.caseId);
            sessionStorage.setItem('Type','COMMISSION')
            sessionStorage.setItem('DANDO',false);
        } else {
            this.props.history.push("/cases/0");
        }
    };


    render() {
        let mainDisplay = <div className={"CorrectiveInfoText"}>Please upgrade to the SCADA Premium platform.</div>;

        if (this.props.commissionEnabled) {
            mainDisplay = <React.Fragment>
                <CommissionSelector commissions={this.props.commissions.commissions_in_current_page}
                    onCommissionClick={this.onCommissionSelect} />
                <Paginator
                    name={"commission-selector"}
                    totalPages={this.props.totalPages}
                    currentPage={this.props.currentPage}
                    setPage={this.props.fetch_commissions} />
            </React.Fragment>
        }

        return (
            <React.Fragment>
                {mainDisplay}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        commissions: state.commissions,
        currentPage: state.commissions.current_page,
        totalPages: state.commissions.total_pages,
        commissionEnabled: state.firmSettings.commissionEnabled
    }
};

const mapDispatchToProps = dispatch => {
    return {
        fetch_commissions: (page) => dispatch(fetch_commissions(page)),
        select_commission: (commission_id) => dispatch(select_commission(commission_id))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CommissionSelectorContainer);


// WEBPACK FOOTER //
// ./src/commissions/components/CommissionSelectorContainer.js